// Purpose: Stock Opname API calls — product options + stock opname check
// Caller: stockOpnameAction
// Dependencies: utils/xhr
// Main Functions: getProductOptions, getStockOpnameCheck
// Side Effects: HTTP GET /product/options, HTTP GET /stock-opname/check

import { xhr } from 'utils'

export const getProductOptions = () => xhr.get('/product/options')

export const getStockOpnameCheck = (params = '') => xhr.get(`/stock-opname/check?${params}`)
